// @codekit-prepend "jquery-2.0.3.min.js"
// @codekit-prepend "jquery.easing-1.3.pack.js"
// @codekit-prepend "bootstrap3.min.js"
// @codekit-prepend "jquery.prettyPhoto.js"
// @codekit-prepend "jquery.bxslider.min.js"
// @codekit-prepend "jquery.cycle.all.js"
// @codekit-prepend "isotope.js"
// @codekit-prepend "jquery.parallax-1.1.3.js"
// @codekit-prepend "appear.js"
// @codekit-prepend "jquery.sticky.js"
// @codekit-prepend "skrollr.js"

//Page Preloader
$(window).load(function() { 
	$("#loader").delay(100).fadeOut(); 
	$(".mask").delay(200).fadeOut(500);
});

$(document).ready(function(){

	//$('.maskme').addClass('mask');

	// open external links in new tab
	$('a[href^=http]').click(function () {
		var a = new RegExp('/' + window.location.host + '/');
		if (!a.test(this.href)) {
			$(this).attr('target','_blank');
		}
	});
	
	//Sticky Navigation		
    $(".navbar").sticky({topSpacing:0});

	//BxSlider

	var onMobile = false;
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) { onMobile = true; }
	$('.fullwidth-slider').bxSlider({
		mode: "fade",
		speed: 600,
		oneToOneTouch: true,
		pager: true,
		easing: 'ease-in-out',
		auto: true,
		pause: 7000,
		//autoHover: true,
		autoControls: true,
		pagerCustom: '#bx-pager',
		
		onSlideBefore: function($slideElement) {
			($slideElement).find('.slide-caption').fadeOut().animate({top:'100px'},{queue:false, easing: 'easeOutQuad', duration: 550});
			($slideElement).find('.slide-caption').hide().animate({top:'-100px'});
		},
		onSlideAfter: function($slideElement) {
			($slideElement).find('.slide-caption').fadeIn().animate({top:'0'},{queue:false, easing: 'easeOutQuad', duration: 450});
		},
		
	});
	
	$('.bx-wrapper .bx-controls-direction a').attr('data-500','top:83%; opacity: 0;').attr('data-start','top:50%; opacity: 1;');
	
	if( ( onMobile === false ) && ( $('.parallax-slider').length ) ) {
	
		skrollr.init({
			edgeStrategy: 'set',
			smoothScrolling: false,
			forceHeight: false
		});
		
	}

	//Navigation Dropdown
	$('.nav a.colapse-menu1').click(function () { $(".nav-collapse").collapse("hide") });
	$('body').on('touchstart.dropdown', '.dropdown-menu', function (e) { e.stopPropagation(); });
	/*$('.navbar-nav .dropdown-toggle').on('click',function(){
		window.location.href = $(this).attr('href');
	});*/

	//Leaving Page Fade Out
	/*$('.navbar a:not(.dropdown-toggle)').on('click',function(){
		var url = $(this).attr('href');
		$('.mask').fadeIn(150, function(){
			document.location.href = url;
		});
		$("#loader").fadeIn("slow");
		return false;
	});*/
	

	//Elements Fading
	$('.element_from_top').each(function () {
		$(this).appear(function() {
		  $(this).delay(150).animate({opacity:1,top:"0px"},1000);
		});	
	});
	
	$('.element_from_bottom').each(function () {
		$(this).appear(function() {
		  $(this).delay(150).animate({opacity:1,bottom:"0px"},1000);
		});	
	});
	
	
	$('.element_from_left').each(function () {
		$(this).appear(function() {
		  $(this).delay(150).animate({opacity:1,left:"0px"},1000);
		});	
	});
	
	
	$('.element_from_right').each(function () {
		$(this).appear(function() {
		  $(this).delay(150).animate({opacity:1,right:"0px"},1000);
		});	
	});
	
	$('.element_fade_in').each(function () {
		$(this).appear(function() {
		  $(this).delay(150).animate({opacity:1,right:"0px"},1000);
		});	
	});


	//Animated Progress Bars
	$('.bar li').each(function () {
		$(this).appear(function() {
		  $(this).animate({opacity:1,left:"0px"},1200);
		  var b = $(this).find("span").attr("data-width");
		  $(this).find("span").animate({
			width: b + "%"
		  }, 1700, "easeOutCirc");
		});	
	});



	// Portfolio Isotope
	var container = $('#portfolio-wrap');

	container.isotope({
		animationEngine : 'best-available',
	  	animationOptions: {
	     	duration: 200,
	     	queue: false
	   	},
		layoutMode: 'fitRows'
	});	

	$('#filters a').click(function(){
		$('#filters a').removeClass('active');
		$(this).addClass('active');
		var selector = $(this).attr('data-filter');
	  	container.isotope({ filter: selector });
        setProjects();		
	  	return false;
	});
		
		
	function splitColumns() { 
		var winWidth = $(window).width(), 
			columnNumb = 1;
		
		
		if (winWidth > 1024) {
			columnNumb = 4;
		} else if (winWidth > 900) {
			columnNumb = 2;
		} else if (winWidth > 479) {
			columnNumb = 2;
		} else if (winWidth < 479) {
			columnNumb = 1;
		}
		
		return columnNumb;
	}		
	
	function setColumns() { 
		var winWidth = $(window).width(), 
			columnNumb = splitColumns(), 
			postWidth = Math.floor(winWidth / columnNumb);
		
		container.find('.portfolio-item').each(function () { 
			$(this).css( { 
				width : postWidth + 'px' 
			});
		});
	}		
	
	function setProjects() { 
		setColumns();
		container.isotope('reLayout');
	}		
	
	container.imagesLoaded(function () { 
		setColumns();
	});

	$(window).bind('resize', function () { 
		setProjects();			
	});


});

//Back To Top
$(function() {
	$('a#back-top').click(function () {
		$('html, body').stop().animate({
			scrollTop: 0
		}, 1500,'easeInOutExpo');
	});
});

//Navigation Scrolling
$(function() {
	$('.nav a, .nav li a, #home-center a, a.move').bind('click',function(event){
		var $anchor = $(this);
		$('html, body').stop().animate({
			scrollTop: $($anchor.attr('href')).offset().top -44
		}, 1500,'easeInOutExpo');
		event.preventDefault();
	});
});

//PrettyPhoto
$(function(){
	$("a[data-gal^='prettyPhoto']").prettyPhoto({
		opacity: 0.5,
		social_tools: "",
		deeplinking: false,
		default_width: 1280,
		default_height: 720,
		theme: "dark_square"
	});
	$("a[rel^='prettyPhoto']").prettyPhoto({
		opacity: 0.5,
		social_tools: "",
		deeplinking: false,
		default_width: 1280,
		default_height: 720,
		theme: "dark_square"
	});
	$("a[data-vid^='prettyPhoto']").prettyPhoto({
		opacity: 0.5,
		social_tools: "",
		deeplinking: false,
		default_width: 1280,
		default_height: 720,
		theme: "dark_square"
	});
});

//Parallax	
$(window).bind('load', function () {
	parallaxInit();						  
});

function parallaxInit() {
	$('.quote-parallax').parallax("100%", 0.1);
}

$(window).load(function() {
	if (document.getElementById("all"))
		document.getElementById("all").click();
});
